"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var ScrollTo = /** @class */ (function (_super) {
    tslib_1.__extends(ScrollTo, _super);
    function ScrollTo(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onWindowScroll = function () {
            var _a = _this.props, minX = _a.minX, minY = _a.minY, target = _a.target;
            var pageOffsetX = target.pageOffsetX, pageOffsetY = target.pageOffsetY;
            var nextState = {};
            nextState.show = scrollX >= minX && scrollY >= minY;
            if (_this.state.show !== nextState.show) {
                _this.setState(nextState);
            }
        };
        _this.stop = function () {
            utils_1.caf(_this.rafId);
            _this.rafId = 0;
        };
        _this.scroll = function (timestamp) {
            var _a = _this.props, duration = _a.duration, target = _a.target;
            var runtime = timestamp - _this.startTime;
            var progress = runtime / duration;
            progress = Math.min(progress, 1);
            var distanceX = Math.abs(_this.startX - _this.props.x);
            var distanceY = Math.abs(_this.startY - _this.props.y);
            var x = Math.abs(_this.startX - distanceX * progress);
            var y = Math.abs(_this.startY - distanceY * progress);
            utils_1.scrollTo(target, x, y);
            if (runtime < duration) {
                _this.rafId = utils_1.raf(_this.scroll);
            }
            else {
                _this.stop();
            }
        };
        _this.performScroll = function (e) {
            var _a = _this.props, onClick = _a.onClick, target = _a.target, x = _a.x, y = _a.y;
            onClick && onClick(e);
            if (_this.rafId > 0 || (target.scrollX === x && target.scrollY === y)) {
                return;
            }
            _this.rafId = utils_1.raf(function (timestamp) {
                _this.startTime = timestamp;
                _this.startX = target.scrollX;
                _this.startY = target.scrollY;
                _this.scroll(timestamp);
            });
        };
        _this.startTime = 0;
        _this.startX = 0;
        _this.startY = 0;
        _this.rafId = 0;
        _this.state = { show: false };
        return _this;
    }
    ScrollTo.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onWindowScroll, { passive: true });
    };
    ScrollTo.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onWindowScroll);
    };
    ScrollTo.prototype.render = function () {
        var children = this.props.children;
        var show = this.state.show;
        return show
            ? React.cloneElement(React.Children.only(children), {
                onClick: this.performScroll
            })
            : null;
    };
    ScrollTo.defaultProps = {
        target: window,
        duration: 200,
        x: 0,
        y: 0,
        minX: 0,
        minY: 0
    };
    return ScrollTo;
}(React.Component));
exports.default = ScrollTo;
